<template>
  <div class="promotion-card promotion-card-warning">
    <div class="promotion-header">
      <div>
        <div class="promotion-type">
          <i class="fa fa-gift" aria-hidden="true"></i>
          ប្រូម៉ូសិនទិញថែម
        </div>
        <div class="promotion-period">
          <span>{{ formatDate(promo.StartDate) }}</span>
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
          <span>{{ formatDate(promo.EndDate) }}</span>
        </div>
      </div>
      <div class="promotion-actions">
        <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('edit', promo)">
          <i class="fa fa-edit" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger" @click="$emit('delete', promo)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="tier-list">
      <div v-for="(line, i) in promo.JsonObject" :key="i" class="tier-row">
        <div>
          <span class="tier-label">ទិញចាប់ពី</span>
          <strong>{{ line.MinQty }}</strong>
        </div>
        <div class="tier-reward">
          <span class="tier-label">ថែមមុខទំនិញ</span>
          <strong>{{ line.ItemName || '-' }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['promo'],
  methods: {
    formatDate(d) {
      return d ? String(d).substr(0, 10) : '-'
    }
  }
}
</script>

<style scoped>
.promotion-card {
  background: #fffaf0;
  border: 1px solid #f4d995;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
}
.promotion-header {
  align-items: center;
  background: #fff3cd;
  border-bottom: 1px solid #f4d995;
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
}
.promotion-type {
  color: #805500;
  font-weight: 700;
}
.promotion-type i {
  margin-right: 6px;
}
.promotion-period {
  align-items: center;
  color: #6f5d2b;
  display: flex;
  font-size: 12px;
  gap: 8px;
  margin-top: 4px;
}
.promotion-actions {
  display: flex;
  gap: 6px;
}
.promotion-actions .btn {
  align-items: center;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 32px;
}
.tier-list {
  display: grid;
  gap: 8px;
  padding: 10px 12px 12px;
}
.tier-row {
  align-items: center;
  background: #fff;
  border: 1px solid #f3dfaa;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
}
.tier-label {
  color: #7d6b37;
  display: block;
  font-size: 11px;
}
.tier-row strong {
  color: #2f353a;
  font-size: 13px;
}
.tier-reward {
  max-width: 70%;
  text-align: right;
}
.tier-reward strong {
  background: #0856ab;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  padding: 3px 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
